// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".advanced-date-block-page{max-width:900px}.advanced-date-block-page .properties-multiselect .lx-label-control-icon{color:#212529 !important}", ""]);
// Exports
module.exports = exports;
